import { CommentArrowLeftIcon } from './CommentArrowLeftIcon';

/**
 * author: Michael Irigoyen
 * id AECA1A18-D8EA-4130-B33C-86D608E030BB
 * name comment-arrow-left
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-arrow-left.svg
 * tags
 */
export const CommentPreviousIcon = CommentArrowLeftIcon;
export default CommentPreviousIcon